<script lang="ts" setup>
withDefaults(
  defineProps<{
    isActive?: boolean
    isDisabled?: boolean
  }>(),
  { isActive: false, isDisabled: false }
)
</script>

<template>
  <li
    class="mx-1 my-0.5 flex min-w-7 items-center justify-center"
    :class="{
      'font-medium text-main-green': isActive && !isDisabled,
      'pointer-events-none': isDisabled,
      'cursor-pointer hover:text-main-green': !isDisabled
    }"
  >
    <slot />
  </li>
</template>
